import { Resource as e } from "@coveo/platform-client";
// src/resources/PipelineInternalResource.ts
var t = class t extends e {
	static {
		this.baseUrl = "/rest/search/v1/admin/pipelines";
	}
	listPipelinesByProjectId(e, n = {}) {
		return this.api.get(this.buildPath(`${t.baseUrl}/projects/list`, {
			...n,
			organizationId: this.api.organizationId,
			projectId: e
		}));
	}
};
export { t as PipelineInternalResource };

//# sourceMappingURL=PipelineInternalResource.js.map